<div class="training-schedule-div">
  <ng-container [formGroup]="AddressForm">
    <div class="content">
      <div class="field ">
        <label [class.required-field]="!isPreviewMode">{{'Address.StreetAddress' | translate}}</label>
        @if (!isPreviewMode) {
          <input (focus)="initAutocomplete()" (click)="initAutocomplete()" id="ship-address" #shipAddressInput autocomplete="off" type="text"
            class='input-text' [class.readonly]="isReadOnlyMode" matInput formControlName="address"
            [placeholder]="'Address.StreetAddressPlaceHolder' | translate" (ngModelChange)="clearFormFields($event)" [readonly]="isReadOnlyMode" />
        }
        @if (isPreviewMode) {
          <label class="answer-text margin-bottom-0"
            >@if (AddressForm.controls['aptSuitUnit'].value) {
            <span>{{AddressForm.controls["aptSuitUnit"].value}} - </span>
          }{{AddressForm.controls["address"].value}}</label>
        }
        @if ((AddressForm.controls['address'].invalid &&  AddressForm.controls['address'].errors &&
          (AddressForm.controls['address'].dirty || AddressForm.controls['address'].touched))) {
          <div>
            @if (AddressForm.controls['address'].hasError('maxlength')) {
              <mat-error>
                {{'Validation.StreetAddress.MaxLength' | translate}}
              </mat-error>
            }
          </div>
        }
        @if (((AddressForm.controls['city'].invalid ||  AddressForm.controls['province'].invalid || AddressForm.controls['postalCode'].invalid)
          && (AddressForm.controls['address'].dirty || AddressForm.controls['address'].touched )  )) {
          <div>
            @if (!isPreviewMode) {
              <div>
                @if (AddressForm.controls['address'].hasError('required')) {
                  <mat-error>
                    {{'Validation.StreetAddress.Required' | translate}}
                  </mat-error>
                }
                @if (!AddressForm.controls['address'].hasError('required')) {
                  <mat-error>
                    {{'Validation.StreetAddress.ValidAddress' | translate}}
                  </mat-error>
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="field ">
        @if (!isPreviewMode) {
          <input #aptSuit type="text" class='input-text' #aptSuitUnitInput matInput [class.readonly]="isReadOnlyMode"
            [readonly]="isReadOnlyMode" [placeholder]="isReadOnlyMode ? '' : 'Address.AptNumberPlaceHolder' | translate" formControlName="aptSuitUnit" />
        }
      </div>
      @if (!hideFields) {
        <div class="field ">
          <label [class.required-field]="!isPreviewMode">{{'Address.CityTown' | translate}}</label>
          @if (!isPreviewMode) {
            <input readonly id="locality" type="text" class='input-text readonly' matInput
              [placeholder]="'Address.CityTownPlaceHolder'  | translate" formControlName="city" />
          }
          @if (isPreviewMode) {
            <label class="answer-text">{{AddressForm.controls["city"].value}}</label>
          }
          @if ((AddressForm.controls['city'].dirty) || AddressForm.controls['city'].touched) {
            <div>
              @if (AddressForm.controls['city'].hasError('required')) {
                <mat-error>
                  {{'Validation.City.Required' | translate}}
                </mat-error>
              }
              @if (AddressForm.controls['city'].hasError('maxlength')) {
                <mat-error>
                  {{'Validation.City.MaxLength' | translate}}
                </mat-error>
              }
            </div>
          }
        </div>
      }
      @if (!hideFields) {
        <div class="field ">
          <label [class.required-field]="!isPreviewMode">{{'Address.Province' | translate}}</label>
          @if (!isPreviewMode) {
            <input readonly id="state" type="text" class='input-text readonly' matInput
              [placeholder]="'Address.ProvincePlaceHolder'  | translate" formControlName="province" />
          }
          @if (isPreviewMode) {
            <label class="answer-text">{{AddressForm.controls["province"].value}}</label>
          }
          @if ((AddressForm.controls['province'].dirty || AddressForm.controls['province'].touched)) {
            <div>
              @if (AddressForm.controls['province'].hasError('required')) {
                <mat-error>
                  {{'Validation.Province.Required' | translate}}
                </mat-error>
              }
            </div>
          }
        </div>
      }
      @if (!hideFields) {
        <div class="field ">
          <label [class.required-field]="!isPreviewMode">{{'Address.PostalCode' | translate}}</label>
          @if (!isPreviewMode) {
            <input readonly id="postcode" type="text" class='input-text readonly' matInput formControlName="postalCode"
              placeholder="{{'Address.PostalCodePlaceHolder' | translate}}" />
          }
          @if (isPreviewMode) {
            <label class="answer-text">{{AddressForm.controls["postalCode"].value}}</label>
          }
          @if ((AddressForm.controls['postalCode'].dirty || AddressForm.controls['postalCode'].touched )) {
            <div>
              @if (AddressForm.controls['postalCode'].hasError('required')) {
                <mat-error>
                  {{'Validation.PostalCode.Required' | translate}}
                </mat-error>
              }
            </div>
          }
        </div>
      }
    </div>
  </ng-container>
</div>
